import Layout from '@/layout';
var tenantRouter = {
  path: '/tenant',
  component: Layout,
  redirect: '/tenant/tenant/index',
  name: 'System',
  alwaysShow: true,
  meta: {
    title: '租户',
    icon: 'clipboard'
  },
  children: [{
    path: 'tenant/index',
    component: function component() {
      return import('@/views/tenant/tenant/index');
    },
    name: '租户管理',
    meta: {
      title: '租户管理'
    }
  }, {
    path: 'tenantPackage/index',
    component: function component() {
      return import('@/views/tenant/tenantPackage/index');
    },
    name: 'tenantPackage',
    meta: {
      title: '租户套餐'
    }
  }, {
    path: 'ds/index',
    component: function component() {
      return import('@/views/tenant/ds/index');
    },
    name: 'ds',
    meta: {
      title: '数据源管理'
    }
  }]
};
export default tenantRouter;